import { login, getInfo, logout } from '@/api/user'
import { getToken, setToken, removeToken,getPartnerId, getPayUrlKey,getHomePage,getName} from '@/utils/auth'
// import md5 from 'md5'

const state = {
  token: getToken(),
  userInfo: null,
  partnerId:getPartnerId(),
  payUrl:getPayUrlKey(),
  homepageUrl:getHomePage(),
  urlName:getName()
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },

}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { account, password, captcha, uuid } = userInfo
    return new Promise((resolve, reject) => {
      // login({ mobile: mobile.trim(), password: md5(password)}).then(response => {
      login({ account: account.trim(), password, captcha, uuid }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.ucToken)
        setToken(data.ucToken)
        resolve(data.ucToken)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo({ 'token': getToken() }).then(response => {
        if (!response.code === 0) {
          reject('验证失败，请重新登录')
        }
        const { data } = response
        commit('SET_USERINFO', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO', '')
        removeToken()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_USERINFO', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

